export const ACCOUNT_BUSINESS_TYPE = Object.freeze({
  SOLE_PROPRIETORSHIP: 'Sole Proprietorship',
  PARTNERSHIP: 'Partnership',
  CORPORATION: 'Corporation',
  CO_OPERATIVE: 'Co-Operative',
  LLC: 'LLC',
  NON_PROFIT: 'Non-Profit',
});
